<template>
    <div class="main">
        <a-card :loading="tableLoading" style="border-radius: 20px;" :bordered="false">

            <div class="actions">
                <h3 style="font-size:28px;line-height:45px">Suppliers</h3>
            </div>
            <div style="display:flex;justify-content: flex-end;margin-bottom: 20px;">

                <a-button @click="showSupplierModal"
                    style="height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                    icon="plus">
                    Add New Supplier
                </a-button>
            </div>
            <div>
                <a-table :columns="supplierColumns" :data-source="tableSupplierData" :loading="tableLoading"
                    :pagination="pagination" class="tableStyle">
                    <div slot="filterDropdown"
                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                        style="padding: 8px">
                        <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                            :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                            Search
                        </a-button>
                        <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                            Reset
                        </a-button>
                    </div>
                    <div slot="filterStatusDropdown" slot-scope="{ clearFilters }"
                        style="padding: 8px;display: flex;flex-direction: column;">
                        <a-select style="width: 190px" @change="e => onInventoryChange(e, clearFilters)">
                            <a-select-option value="all">
                                All
                            </a-select-option>
                            <a-select-option value="1">
                                Enabled
                            </a-select-option>
                            <a-select-option value="0">
                                Disabled
                            </a-select-option>
                        </a-select>
                    </div>
                    <template slot="action" slot-scope="data">
                        <a-dropdown>
                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                <a-icon style="font-size:25px;" type="ellipsis" />
                            </a>
                            <a-menu slot="overlay">
                                <a-menu-item>
                                    <a @click="showUpdateSupplierModel(data)">Edit Supplier?</a>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </template>


                    <template slot="status" slot-scope="data">
                        <div v-if="data.status === 1">
                            <a-switch default-checked checkedChildren="Enabled" unCheckedChildren="Disabled"
                                @change="supplierOnChange" @click="switchStatus(data)" />
                        </div>
                        <div v-else>
                            <a-switch checkedChildren="Enabled" unCheckedChildren="Disabled" @change="supplierOnChange"
                                @click="switchStatus(data)" />
                        </div>
                    </template>
                </a-table>
            </div>

            <a-modal class="modalStyle" :visible="addSupplierVisible" :footer="null" @cancel="handleAddSupplierCancel">

                <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">
                    Add
                    Supplier</p>
                <div>
                    <a-form-model ref="addSupplierForm" :model="addSupplierModel" :rules="rules">
                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Name" ref="supplierName" prop="supplierName">
                                    <a-input class="" v-model="addSupplierModel.supplierName" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="2">
                                <a-form-model-item label="Address" ref="supplierAddress" prop="supplierAddress">
                                    <a-input class="" v-model="addSupplierModel.supplierAddress" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Phone Number" ref="supplierPhoneNumber"
                                    prop="supplierPhoneNumber">
                                    <a-input class="" v-model="addSupplierModel.supplierPhoneNumber" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="2">
                                <a-form-model-item label="Supplier Type" ref="supplierType" prop="supplierType">
                                    <a-select v-model="addSupplierModel.supplierType">
                                        <a-select-option value="1">
                                            Hatchery
                                        </a-select-option>
                                        <a-select-option value="0">
                                            Product
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="22" :offset="1">
                                <a-form-model-item label="Supplier Description" ref="supplierDescription"
                                    prop="supplierDescription">
                                    <a-textarea v-model="addSupplierModel.supplierDescription"
                                        placeholder="Enter description...." :auto-size="{ minRows: 3, maxRows: 5 }" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>

                        <a-form-model-item
                            style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                            <a-button @click="handleAddSupplierSubmit" :loading="loading"
                                style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Add Supplier
                            </a-button>
                        </a-form-model-item>

                    </a-form-model>
                </div>
            </a-modal>
            <a-modal class="modalStyle" :visible="updateSupplierVisible" :footer="null"
                @cancel="handleUpdateSupplierCancel">

                <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">
                    Edit
                    Supplier</p>
                <div>
                    <a-form-model ref="updateSupplierForm" :model="updateSupplierModel" :rules="rules">
                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Supplier Name" ref="supplierName" prop="supplierName">
                                    <a-input class="" v-model="updateSupplierModel.supplierName" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="2">
                                <a-form-model-item label="Supplier Address" ref="supplierAddress"
                                    prop="supplierAddress">
                                    <a-input class="" v-model="updateSupplierModel.supplierAddress" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Supplier Phone Number" ref="supplierPhoneNumber"
                                    prop="supplierPhoneNumber">
                                    <a-input class="" v-model="updateSupplierModel.supplierPhoneNumber" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="2">
                                <a-form-model-item label="Supplier Type" ref="supplierType" prop="supplierType">
                                    <a-select v-model="updateSupplierModel.supplierType">
                                        <a-select-option value="1">
                                            Hatchery
                                        </a-select-option>
                                        <a-select-option value="0">
                                            Product
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                        </a-row>

                        <a-row>
                            <a-col :span="22" :offset="1">
                                <a-form-model-item label="Supplier Description" ref="supplierDescription"
                                    prop="supplierDescription">
                                    <a-textarea v-model="updateSupplierModel.supplierDescription"
                                        placeholder="Enter description...." :auto-size="{ minRows: 3, maxRows: 5 }" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>

                        <a-form-model-item
                            style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                            <a-button :loading="loading" @click="handleEditSupplierSubmit"
                                style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Edit Supplier
                            </a-button>
                        </a-form-model-item>

                    </a-form-model>
                </div>
            </a-modal>
        </a-card>
    </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

const supplierColumns = [
    {
        title: 'Supplier ID',
        // width: 150,
        key: 'id',
        dataIndex: 'id',
    },
    {
        title: 'Supplier Name',
        // width: 150,
        key: 'name',
        dataIndex: 'name',
        scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
            record.name
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
    },
    {
        title: 'Region',
        // width: 150,
        key: 'address',
        dataIndex: 'address',
    },
    {
        title: 'Created At',
        // width: 150,
        key: 'dateCreated',
        dataIndex: 'dateCreated',
    },
    {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        scopedSlots: {
        customRender: "status",
        filterDropdown: 'filterStatusDropdown',
        filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
            record.status
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
    },
    {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' }
    },

]
    export default {
        name: 'Supplier',
        data(){
            return{
                tableSupplierData:[],
                tableLoading: false,
                supplierColumns,
                pagination: {
                    pageSize:20
                },
                isSupplierEnabled: Boolean,
                params:{
                    page: -1,
                    perPage:-1,
                    searchBy: {},
                    sortBy: {}
                },
                searchText: '',
                searchInput: null,
                searchedColumn: '',
                addSupplierModel:{
                    supplierName: '',
                    supplierAddress: '',
                    supplierPhoneNumber:'',
                    supplierDescription: '',
                    supplierType: ''
                },
                updateSupplierModel: {
                    supplierName: '',
                    supplierAddress: '',
                    supplierPhoneNumber:'',
                    supplierDescription: '',
                    supplierType: ''
                },
                addSupplierVisible: false,
                updateSupplierVisible: false,
                dateFormat: 'DD/MM/YYYY',
                startDate: moment(),
                endDate: moment(),
                loading: false,
                selectedSupplier:{},
                rules:{
                    notes: [
                        { required: true, message: 'Please this field cannot be empty' , trigger: 'change'},
                    ],
                    name: [
                        { required: true, message: 'Please enter name' , trigger: 'change'},
                    ],
                    
                    manufacturerName: [
                        { required: true, message: 'Please enter name' , trigger: 'change'},
                    ],
                    description: [
                        { required: true, message: 'Please enter description' , trigger: 'change'},
                    ],
                    manufacturerDescription: [
                        { required: true, message: 'Please enter description' , trigger: 'change'},
                    ],
                    supplierName: [
                        { required: true, message: 'Please enter name' , trigger: 'change'},
                    ],
                    supplierAddress: [
                        { required: true, message: 'Please enter address' , trigger: 'change'},
                    ],
                    supplierPhoneNumber: [
                        { required: true, message: 'Please enter phone number' , trigger: 'change'},
                    ],
                    supplierType: [
                        { required: true, message: 'Please select supplier type', trigger: 'change' },
                    ],
                    supplierDescription: [
                        { required: true, message: 'Please enter description' , trigger: 'change'},
                    ],
                    categoryName: [
                        { required: true, message: 'Please enter name' , trigger: 'change'},
                    ],
                    categoryDescription: [
                        { required: true, message: 'Please enter description' , trigger: 'change'},
                    ],
                    categoryGroup: [
                        { required: true, message: 'Please select your option' , trigger: 'change'},
                    ],
                    isRestricted: [
                        { required: true, message: 'Please select your option' , trigger: 'change'},
                    ],
                    categoryCommission: [
                        { required: true, message: 'Please enter commission', trigger: 'change' },
                        {   
                                pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),  
                                message: 'Please enter valid number', 
                                trigger: 'change'
                        },
                    ],
                }
            }
        },
        computed:{
            ...mapGetters(['IsAgentProfileAvailable']),
        },
        methods:{
          ...mapActions(['getAllProductsMgtData','addProductSupplier','updateProductSupplier']),
          onChange(date, dateString) {
                // console.log(date, dateString);
                this.startDate = dateString[0];
                this.endDate = dateString[1];
                // console.log("startDate | ", this.startDate);
                // console.log("endDate | ", this.endDate);
            },
            moment,
            handleSearch(selectedKeys, confirm, dataIndex) {
                confirm();
                this.searchText = selectedKeys[0];
                this.searchedColumn = dataIndex;
            },
            handleReset(clearFilters) {
                clearFilters();
                this.searchText = '';
            },
            showSupplierModal(){
                this.addSupplierVisible = true;
            },
            supplierOnChange(checked){
                this.isSupplierEnabled = checked
            },
            showUpdateSupplierModel(data){
                this.selectedSupplier = data
                this.updateSupplierModel.supplierName = data.name
                this.updateSupplierModel.supplierAddress = data.address
                this.updateSupplierModel.supplierPhoneNumber = data.phoneNumber ? data.phoneNumber : ''
                this.updateSupplierModel.supplierDescription = data.metadata.description ? data.metadata.description : ''
                this.updateSupplierModel.supplierType = data.type.toString()
                
                this.updateSupplierVisible = true;
            },
            handleUpdateSupplierCancel(){
                this.updateSupplierVisible = false;
            },
            handleAddSupplierCancel(){
                this.addSupplierVisible = false;
            },
             handleAddSupplierSubmit(){
                this.$refs.addSupplierForm.validate(valid => {
                        if (valid) {
                            this.loading = true;
                            const request = {
                                name:  this.addSupplierModel.supplierName,
                                address: this.addSupplierModel.supplierAddress,
                                phoneNumber: this.addSupplierModel.supplierPhoneNumber,
                                type: this.addSupplierModel.supplierType ? parseInt(this.addSupplierModel.supplierType) : null,
                                metadata:{
                                    description: this.addSupplierModel.supplierDescription,
                                },
                                status: 1
                            }
 
                            this.addProductSupplier(request).then(response => {
                                
                                this.loading = false;
                                if(response.status === 200){
                                    this.getProductsMgtData();
                                    this.showSuccessAlert("Supplier Added Successfully")
                                    this.addSupplierVisible = false;
                                    this.$refs.addSupplierForm.resetFields();
                                }else{
                                    this.showErrorAlert(response.data.messages)
                                }
                            },
                            error =>{
                                this.loading = false
                                this.showErrorAlert(JSON.stringify(error))
                            })                    
                        } else {
                            // console.log('error submit!!');
                            return false;
                        }
                });
            },
            handleEditSupplierSubmit(){
                this.$refs.updateSupplierForm.validate(valid => {
                        if (valid) {
                            this.loading = true;
                            const request = {
                                id: this.selectedSupplier.id,
                                data: {
                                    name:  this.updateSupplierModel.supplierName,
                                    address: this.updateSupplierModel.supplierAddress,
                                    phoneNumber: this.updateSupplierModel.supplierPhoneNumber,
                                    type: this.updateSupplierModel.supplierType ? parseInt(this.updateSupplierModel.supplierType) : null,
                                    metadata:{
                                        description: this.updateSupplierModel.supplierDescription,
                                    },
                                    status: this.selectedSupplier.status
                                }
                            }
                    
                            this.updateProductSupplier(request).then(response => {
                                
                                this.loading = false;
                                if(response.status === 200){
                                    this.getProductsMgtData();
                                    this.showSuccessAlert("Supplier Updated Successfully")
                                    this.updateSupplierVisible = false;
                                    this.$refs.updateSupplierForm.resetFields();
                                }else{
                                    this.showErrorAlert(response.data.messages)
                                }
                            },
                            error =>{
                                this.loading = false
                                this.showErrorAlert(JSON.stringify(error))
                            })                    
                        } else {
                            // console.log('error submit!!');
                            return false;
                        }
                });
            },
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
             switchStatus(data){
                this.tableLoading = true
            
                const request = {
                    id: data.id,
                    data: {
                        name:  data.name,
                        address: data.address,
                        metadata:{
                            phoneNumber: data.metadata.phoneNumber,
                            description: data.metadata.description,
                        },
                        status: this.isSupplierEnabled === true ? 1 : 0
                    }
                }
                
                
                this.updateProductSupplier(request).then(response => {
                    
                    this.tableLoading = false;
                    if(response.status === 200){
                        this.getProductsMgtData();
                        if(this.isSupplierEnabled){
                            this.showSuccessAlert(`Supplier [ ${data.name} ] Enabled Successfully`)
                        }else{
                            this.showSuccessAlert(`Supplier [ ${data.name} ] Disabled Successfully`)
                        }
                    }else{
                        this.tableLoading = false;
                        this.showErrorAlert(response.data.messages)
                    }
                },
                error =>{
                    this.tableLoading = false
                    this.showErrorAlert(JSON.stringify(error))
                }) 
            },
            onInventoryChange(value, clearFilters){
                let result = []
                if(value === 'all'){
                    result = this.availableSuppliers
                }else {
                    result = this.availableSuppliers.filter(invoice => parseInt(invoice.status) === parseInt(value) )
                }
                this.tableSupplierData = result.map(supplier => ({
                    id: supplier.id,
                    key: supplier.id,
                    name: supplier.name,
                    address: supplier.address ? supplier.address : 'N/A',
                    status: supplier,
                    isRestricted: supplier.isRestricted === true ? 'Yes' : 'No',
                    dateCreated: moment(supplier.createdAt).format('DD-MM-YYYY'),
                    action: supplier
                }))
                clearFilters();
            },
            getAllSuppliersData(response){
             if(response.status === 200){
                this.availableSuppliers = response.data.data
                this.tableSupplierData = response.data.data.map(supplier => ({
                    id: supplier.id,
                    key: supplier.id,
                    name: supplier.name,
                    address: supplier.address ? supplier.address : 'N/A',
                    status: supplier,
                    isRestricted: supplier.isRestricted === true ? 'Yes' : 'No',
                    dateCreated: moment(supplier.createdAt).format('DD-MM-YYYY'),
                    action: supplier
                }))
                // this.tableCategoryData =  _.orderBy(result, ['dateCreated'],['desc'])
            }else{
                console.log("Error | " , response)
            }
        },
        async getProductsMgtData(){
            this.tableLoading =  true;
            const response = await this.getAllProductsMgtData();
            this.getAllSuppliersData(response[2])
        
            this.tableLoading =  false;
        }
           
        },
        created() {
          
          if(this.getProductsMgtData){
              this.getProductsMgtData();
          }
         
        }
    }
</script>

<style scoped>

.actions{
    display: flex;
    justify-content: space-between;
}
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}
.orderTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.orderTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.orderTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.orderTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
a {
  color: #418a49;
}
a:hover{
  color: #418a49;
}

.orderTable >>> .ant-spin-dot-item {
    background-color: #418a49;
}

.ant-switch-checked {
    background-color: #418a49;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}


.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}

</style>